import * as React from "react";
import { Container } from "@mui/material";

interface ResponsiveContainerProps {
  children: React.ReactNode;
}

/** Constrains dashboard content width on very large monitors while remaining fluid on smaller viewports. */
export function ResponsiveContainer({ children }: ResponsiveContainerProps): React.JSX.Element {
  return (
    <Container maxWidth="xl" disableGutters>
      {children}
    </Container>
  );
}
